import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_UNBLOCK_LIST } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";


// export function fetchAllUnblockList(filter, callback) {


//     return (dispatch) => {
//       const request = axiosHelper.get(`${APIUSEROLD.getAllUnblockList}`, {
//         params: {
//           employeeId: filter?.EmployeeId,
//           page: filter.current_page,
//           applicationNo: filter?.ApplicationNo,
//           supplierCategory: filter?.CategoryName,
//           requestStatus: filter?.Status,
//           plant: filter?.PlantName,
//           supplierName:filter?.SupplierName,
//           pageSize: filter.per_page,
//           SearchText: filter?.sortField?.supplierName,
//           requestedBy:filter?.RequestedBy,
//           SortBy: filter?.sortField,
//           SortOrder: filter.sortOrder,
//           RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
//         RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
//         }, // Assuming filter contains necessary query parameters
//       });
//       request
//         .then((response) => {
//           if (response?.data || response.status === 204) {
//             dispatch({
//               type: GET_ALL_UNBLOCK_LIST,
//               payload: {
//                 data: response.status === 204 ? [] : response?.data?.Result,

//                 filter, // Include filter in payload
//               },
//             });
//             callback(response, null);
//           }
//         })
//         .catch((error) => {
//           dispatch({ type: API_FAILURE });
//           callback(null, error);
//           // apiErrors(error);
//         });
//     };
//   }
export function fetchAllUnblockList(filter) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAllUnblockList}`, {
      params: {
        employeeId: filter?.EmployeeId,
        page: filter.current_page,
        applicationNo: filter?.ApplicationNo,
        supplierCategory: filter?.CategoryName,
        requestStatus: filter?.Status,
        vendorCode: filter?.VendorCode,
        plant: filter?.PlantName,
        supplierName: filter?.SupplierName,
        pageSize: filter.per_page,
        SearchText: filter?.sortField?.supplierName,
        requestedBy: filter?.RequestedBy,
        SortBy: filter?.sortField,
        SortOrder: filter.sortOrder,
        RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
        RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
      }, // Assuming filter contains necessary query parameters
    });

    return request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ALL_UNBLOCK_LIST,
            payload: {
              data: response.status === 204 ? [] : response?.data?.Result,
              filter, // Include filter in payload
            },
          });
          return response;
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          throw error;
        }
      });
  };
}